import * as actions from '../utils/Constants';
import { apiRequest, Methods} from '../utils/Api';

export const getCourses = (sessionId) => {
    return dispatch => dispatch({
        type: actions.GET_COURSES,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/session/${sessionId}/courses/`, Methods.get, null, dispatch)
    });
};

export const getSections = (sessionId) => {
    return dispatch => dispatch({
        type: actions.GET_COURSES,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/session/${sessionId}/sections/`, Methods.get, null, dispatch)
    });
};

export const deleteCourses = (sessionId, ids = []) => {
    return dispatch => dispatch({
        type: actions.DELETE_COURSES,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/courses/`, Methods.delete, ids, dispatch).then(res => {
            dispatch(getCourses(sessionId));
            return {};
        })
    })
}

export const deleteSections = (sessionId, ids = []) => {
    return dispatch => dispatch({
        type: actions.DELETE_SECTIONS,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/courses/`, Methods.delete, ids, dispatch).then(res => {
            dispatch(getSections(sessionId));
            return {};
        })
    })
}

export const toggleSectionVisability = (id) => {
    return {
        type: actions.TOGGLE_COURSE_SECTION_VISABILITY,
        payload: id
    }
}

export const newCourse = () => ({ type: actions.NEW_COURSE })

export const newSection = () => ({ type: actions.NEW_SECTION, payload: 0 })

